
import { mapActions, mapGetters } from 'vuex'

const MAX_REVIEWS = 9
const DESKTOP_PER_SLIDE = 3
const MOBILE_PER_SLIDE = 1
const MOBILE_BREAKPOINT = '(max-width: 767px)'

export default {
  name: 'GoogleReviews',
  data () {
    return {
      slideIndex: 0,
      isMobile: false,
      mediaQuery: null,
      mediaListener: null
    }
  },
  computed: {
    ...mapGetters(['googleReviews', 'currentStore']),
    perSlide () {
      return this.isMobile ? MOBILE_PER_SLIDE : DESKTOP_PER_SLIDE
    },
    slideGroups () {
      const reviews = this.googleReviews.slice(0, MAX_REVIEWS)
      const groups = []
      for (let i = 0; i < reviews.length; i += this.perSlide) {
        groups.push(reviews.slice(i, i + this.perSlide))
      }
      return groups
    }
  },
  watch: {
    currentStore () {
      this.slideIndex = 0
      this.getGoogleReviews()
    },
    perSlide () {
      this.slideIndex = 0
    }
  },
  mounted () {
    this.getGoogleReviews()
    if (typeof window !== 'undefined' && window.matchMedia) {
      this.mediaQuery = window.matchMedia(MOBILE_BREAKPOINT)
      this.isMobile = this.mediaQuery.matches
      this.mediaListener = (e) => { this.isMobile = e.matches }
      if (this.mediaQuery.addEventListener) {
        this.mediaQuery.addEventListener('change', this.mediaListener)
      } else {
        this.mediaQuery.addListener(this.mediaListener)
      }
    }
  },
  beforeDestroy () {
    if (this.mediaQuery && this.mediaListener) {
      if (this.mediaQuery.removeEventListener) {
        this.mediaQuery.removeEventListener('change', this.mediaListener)
      } else {
        this.mediaQuery.removeListener(this.mediaListener)
      }
    }
  },
  methods: {
    ...mapActions(['getGoogleReviews'])
  }
}
